import { appNames } from "../constants/appNames";
// import domtoimage from "dom-to-image";
// import jsPDF from "jspdf";
import { useToast } from '../components/Toast/ToastContext';
import Vector from '../assets/Vector.png'
import { Card, Icon, LoadingSpinner, Modal, Tooltip, ButtonGroup, Toggle } from 'pepsico-ds'
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";
import domtoimagejpeg from "dom-to-image-more";
import { setKeyValue } from "../redux/reducer/localDataSlice";
import { localStoreKeys } from "../constants/localStoreKeys";

/* istanbul ignore next */
export const call7DaysNpsLogic = (dispatch, userData) => {
            dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // 7 days NPS logic
            const now = Date.now(); // current timestamp in milliseconds

            const responseDate = new Date(userData?.mostRecentDate).getTime(); // convert to timestamp in ms

            const diffInMs = Math.abs(now - responseDate); // difference in milliseconds

            const daysDiff = diffInMs / (1000 * 60 * 60 * 24); // convert ms to days

            if (daysDiff >= 7) {
                dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            } else {
                dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: true }))
            }
}

/* istanbul ignore next */
export const svgDropdownIcon = (isModal, refName, kpiName, isTable, dropdownRef,toggleDropdown, open, spendResilincDropdownoptions, setIsDownloadSingleBarChart, setIsJpegDownloaded, setCurrentStateRef, setCurrentKPIName, setOpen) => {
  return(
  <>
      <div ref={dropdownRef} 
       style={{ position: "relative", display: "inline-block", background: 'white', 
                height: '30px', borderRadius: '5px', border: '1px solid #d3caca'}}>
      {/* Trigger Button */}
      <div style={{display: 'flex'}}>
      <Tooltip text={isModal ? 'Download Full Page' : isTable ? 'Download this table' : 'Download this chart'} direction={isModal ? "left": "top-middle"} style={{display: 'flex !important', zIndex: '999999'}}>
          <button
          onClick={toggleDropdown}
          style={{
              background: "white",
              border: "none",
              cursor: "pointer",
              display: 'flex',
              position: 'relative',
              top: '0.35rem'
          }}
          className="spend-download-btn"
          >
          <Icon
              alt="alt value"
              icon={"download"}
              size="small"
              style={{ color: '#005cbc' }}
          />
          <Icon
              alt="alt value"
              icon={"arrow_drop_down"}
              size="small"
              style={{ color: '#005cbc' }}
          />
          {/* <img src={DownloadFileFormat} alt="download" /> */}
          </button>
      </Tooltip>
      </div>

      {/* Dropdown Menu */}
      {open && (
          <ul
          style={{
              position: "absolute",
              // top: "120%",
              right: 0,
              background: "white",
              listStyle: "none",
              padding: "4px 0",
              margin: 0,
              border: "1px solid #ddd",
              borderRadius: "6px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              minWidth: "150px",
              fontSize: "12px",
              zIndex: '99999'
          }}
          className="spend-download-btn-options"
          >
          {spendResilincDropdownoptions.map((opt, idx) => (
              <li
              key={idx}
              style={{
                  padding: "0 5px",
                  display: "flex",
                  alignItems: "center",
                  height: '1.5rem',
                  cursor: "pointer",
              }}
              onClick={() => {
                  setIsDownloadSingleBarChart(true);
                  setIsJpegDownloaded(opt.label == "Download as JPEG" ? true : false)
                  setCurrentStateRef(refName);
                  setCurrentKPIName(kpiName)
                  setOpen(false);
              }}
              onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#f5f5f5")
              }
              onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "transparent")
              }
              >
              {opt.icon}
              <span style={{ marginLeft: "6px", fontWeight: '500' }}>{opt.label}</span>
              </li>
          ))}
          </ul>
      )}
      </div>
  </>
  )
}

/* istanbul ignore next */
export const getUTCDate = (d) => {
  return new Date(Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate()
    ))?.toISOString();
}

// export const timerCardLayout = (allowMovement, inactiveModal, setInactiveModal, setAllowMovement) => {
//   if(allowMovement && !inactiveModal){
			
//     const startTime = Date.now();
//     const duration = 2.5 * 60 * 1000; // 2min 30sec in ms

//     const intervalId = setInterval(() => {
//     const elapsed = Date.now() - startTime;

//     if (elapsed >= duration) {
//       clearInterval(intervalId);
//       if(allowMovement){
//         setInactiveModal(true)
//       }
      
//     }
//     }, 1000); // run every second
    
//     return () => clearInterval(intervalId);
//   } 

//   if(inactiveModal){
//     const startTime = Date.now();
//     const duration = 5 * 60 * 1000; // 2min 30sec in ms

//     const intervalId = setInterval(() => {
//     const elapsed = Date.now() - startTime;


//     if (elapsed >= duration) {
//       clearInterval(intervalId);

//       setInactiveModal(false)
//       setAllowMovement(false)
//     }
//     }, 1000); // run every second
    
//     return () => clearInterval(intervalId);
//   }
// }

/* istanbul ignore next */
export const timerCardLayout = (
  allowMovement,
  inactiveModal,
  setInactiveModal,
  setAllowMovement
) => {
  if (allowMovement && !inactiveModal) {
    const startTime = Date.now();
    const duration = 2.5 * 60 * 1000;

    const intervalId = setInterval(() => {
      const elapsed = Date.now() - startTime;
      if (elapsed >= duration) {
        clearInterval(intervalId);
        setInactiveModal(true);
      }
    }, 1000);

    return intervalId;
  }

  if (inactiveModal) {
    const startTime = Date.now();
    const duration = 5 * 60 * 1000;

    const intervalId = setInterval(() => {
      const elapsed = Date.now() - startTime;

      if (elapsed >= duration) {
        clearInterval(intervalId);
        setInactiveModal(false);
        setAllowMovement(false);
      }
    }, 1000);

    return intervalId;
  }

  return null;
};

export const dragEndHandle = (item, newIdx, oldIdx, updatedList, setCardUpdatedList, setDisableResetSaveBtn) => {
  setCardUpdatedList(updatedList)
  
  let flag = true;

  for (let i = 0; i < updatedList.length; i++) {
  const expectedId = `card-${i}`;
  if (updatedList[i].id !== expectedId) {
    flag = false;
    break;
  }
  }
  setDisableResetSaveBtn(flag)
}

function addCoManCardIfMissing(cardsArray) {
    // Check if coman-card exists in the array
    const coManCardExists = cardsArray.some(card => card.phCardId === "coman-card");
    
    // If coman-card doesn't exist, add it
    if (!coManCardExists) {
      // Find the maximum sortOrder
      const maxSortOrder = cardsArray.reduce((max, card) =>
        Math.max(max, card.sortOrder), 0);
      
      // Create new coman-card with the next sortOrder
      const coManCard = {
        "phCardId": "coman-card",
        "sortOrder": maxSortOrder + 1
      };
      
      // Add the new card to the array
      return [...cardsArray, coManCard];
    }
    
    // If coman-card already exists, return the original array
    return cardsArray;
}

/* istanbul ignore next */
function addCategoryManagementCardIfMissing(cardsArray) {
    // Check if CategoryManagement exists in the array
    const categoryManagementCardExists = cardsArray.some(card => card.phCardId === "category-management-card");

    if (!categoryManagementCardExists) {
        // Find the maximum sortOrder
        const maxSortOrder = cardsArray.reduce((max, card) =>
          Math.max(max, card.sortOrder), 0);
        
        // Create new category-management-card with the next sortOrder
        const categoryManagementCard = {
          "phCardId": "category-management-card",
          "sortOrder": maxSortOrder + 1
        };
        
        // Add the new card to the array
        return [...cardsArray, categoryManagementCard];
      }
    
    // If category-management-card already exists, return the original array
    return cardsArray;
}

/* istanbul ignore next */
function addProcurementPerformanceCardIfMissing(cardsArray) {
    // Check if ProcurementPerformance exists in the array
    const ProcurementPerformanceCardExists = cardsArray.some(card => card.phCardId === "procurement-performance-card");
    if (!ProcurementPerformanceCardExists) {
        // Find the maximum sortOrder
        const maxSortOrder = cardsArray.reduce((max, card) =>
          Math.max(max, card.sortOrder), 0);
        
        // Create new procurement-performance-card with the next sortOrder
        const ProcurementPerformanceCard = {
          "phCardId": "procurement-performance-card",
          "sortOrder": maxSortOrder + 1
        };
        
        // Add the new card to the array
        return [...cardsArray, ProcurementPerformanceCard];
      }
    
    // If ProcurementPerformance-card already exists, return the original array
    return cardsArray;
}
/* istanbul ignore next */
function addCompassCardIfMissingPGCSUser(cardsArray) {
    // Check if Compass-card exists in the array
    const compassCardExists = cardsArray.some(card => card.phCardId === "compass-card");
    
    // If Compass-card doesn't exist, add it
    if (!compassCardExists) {
      // Find the maximum sortOrder
      const maxSortOrder = cardsArray.reduce((max, card) =>
        Math.max(max, card.sortOrder), 0);
      
      // Create new Compass-card with the next sortOrder
      const compassCard = {
        "phCardId": "compass-card",
        "sortOrder": maxSortOrder + 1
      };
      
      // Add the new card to the array
      return [...cardsArray, compassCard];
    }
    
    // If Compass-card already exists, return the original array
    return cardsArray;
}

/* istanbul ignore next */
function addPGCSCardIfMissingPGCSUser(cardsArray, initialKpiTilesOrderData) {
   // Check if PGCS-card exists in the array
    const pgcsCardExists = cardsArray.some(card => card.phCardId === "pgcs-analytics-card");
    
    // If PGCS-card doesn't exist, add it
    if (!pgcsCardExists) {
      // Find the maximum sortOrder
      const maxSortOrder = cardsArray.reduce((max, card) =>
        Math.max(max, card.sortOrder), 0);
      
      // Create new PGCS-card with the next sortOrder
      const pgcsCard = {
        "phCardId": "pgcs-analytics-card",
        "sortOrder": maxSortOrder + 1
      };
      
      // Add the new card to the array
      return [...cardsArray, pgcsCard];
    }
    
    // If PGCS-card already exists, return the original array
    return cardsArray;
}

export const buildFileName = (kpiName, ext) => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${kpiName}_${yyyy}${mm}${dd}.${ext}`;
  };

export async function generateJpegFromNode({
    node,
    fileName,
    quality = 1.0,
    style = {},
  }) {
    const finalStyle = {
      backgroundColor: "#ffffff", // required for JPEG
      padding: "10px",
      ...style,
    };
  
    const dataUrl = await domtoimagejpeg.toJpeg(node, {
      quality,
      style: finalStyle,
    });
  
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = fileName;
    link.click();
  }

/**
 * Trim white / transparent borders from image
 */
export async function trimImageWhitespace(dataUrl) {
    const img = new Image();
    img.src = dataUrl;
    await new Promise((res, rej) => {
      img.onload = res;
      img.onerror = rej;
    });
  
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
  
    const w = canvas.width;
    const h = canvas.height;
    const imgData = ctx.getImageData(0, 0, w, h).data;
  
    // helper tests whether a pixel is 'non-white/non-transparent'
    const isContent = (i) => {
      const r = imgData[i], g = imgData[i + 1], b = imgData[i + 2], a = imgData[i + 3];
      if (a > 10) { // some alpha means content
        // treat near-white as background; adjust threshold as needed
        return !(r > 245 && g > 245 && b > 245);
      }
      return false;
    };
  
    let top = 0, bottom = h - 1, left = 0, right = w - 1;
    let found = false;
  
    // top
    for (let yy = 0; yy < h; yy++) {
      for (let xx = 0; xx < w; xx++) {
        if (isContent((yy * w + xx) * 4)) {
          top = yy;
          found = true;
          break;
        }
      }
      if (found) break;
    }
    if (!found) return dataUrl; // blank image
  
    // bottom
    for (let yy = h - 1; yy >= 0; yy--) {
      for (let xx = 0; xx < w; xx++) {
        if (isContent((yy * w + xx) * 4)) {
          bottom = yy;
          yy = -1; // break outer
          break;
        }
      }
    }
    // left
    found = false;
    for (let xx = 0; xx < w; xx++) {
      for (let yy = top; yy <= bottom; yy++) {
        if (isContent((yy * w + xx) * 4)) {
          left = xx;
          found = true;
          break;
        }
      }
      if (found) break;
    }
    // right
    found = false;
    for (let xx = w - 1; xx >= 0; xx--) {
      for (let yy = top; yy <= bottom; yy++) {
        if (isContent((yy * w + xx) * 4)) {
          right = xx;
          found = true;
          break;
        }
      }
      if (found) break;
    }
  
    const cropW = right - left + 1;
    const cropH = bottom - top + 1;
    if (cropW <= 0 || cropH <= 0) return dataUrl;
  
    const out = document.createElement("canvas");
    out.width = cropW;
    out.height = cropH;
    out.getContext("2d").drawImage(canvas, left, top, cropW, cropH, 0, 0, cropW, cropH);
    return out.toDataURL("image/png");
  }

/**
 * Common DOM → PDF generator
 */
export async function generatePdfFromNode({
  node,
  currentKPIName,
  opts = {},
}) {
    const {
        fitMode = "top",      // 'contain' | 'cover' | 'top'
        imageScale = 2,         // 1 = native; 2 = double resolution (better for upscaling)
        marginMm = 8,           // page margin in mm
        trimWhitespace = false, // slow, optional: trims uniform white/transparent borders
        pdfFormat = "a4",
        orientation = "portrait",
    } = opts;

    const dataUrl = await domtoimage.toPng(node, {
        bgcolor: "#ffffff", // avoid transparency causing trim issues
        quality: 1,
        cacheBust: true,
        // Render at a higher pixel size to avoid blur when we scale up in the PDF.
        width: node.scrollWidth * imageScale,
        height: node.scrollHeight * imageScale,
        style: {
          transform: `scale(${imageScale})`,
          transformOrigin: "top left",
   }});

   // optional: trim whitespace pixels from edges (slow)
  const finalDataUrl = trimWhitespace ? await trimImageWhitespace(dataUrl) : dataUrl;

   const pdf = new jsPDF({
       orientation: "portrait",
       unit: "mm",
       format: "a4", // A2 paper size
   });

   const imgProps = pdf.getImageProperties(finalDataUrl);
  if (!imgProps || !imgProps.width || !imgProps.height) {
    throw new Error("Invalid image properties from generated image.");
  }

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const usableW = pageWidth - 2 * marginMm;
  const usableH = pageHeight - 2 * marginMm;

  // Start by fitting to usable width (same approach you had)
  let pdfWidth = usableW;
  let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  if (fitMode === "contain") {
    // If height overflows, shrink to usable height instead (maintain aspect)
    if (pdfHeight > usableH) {
      pdfHeight = usableH;
      pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
    }
  } else if (fitMode === "cover") {
    // If fitted height is smaller than usable, scale up to cover the usable height
    // (this will likely make pdfWidth > usableW and will crop horizontally,
    // but removes top/bottom whitespace)
    if (pdfHeight < usableH) {
      const scaleUp = usableH / pdfHeight;
      pdfWidth *= scaleUp;
      pdfHeight = usableH;
    }
    // (If pdfHeight already > usableH then we're already covering vertically.)
  } else if (fitMode === "top") {
    // Fit by width, but align to top margin instead of centering.
    if (pdfHeight > usableH) {
      pdfHeight = usableH;
      pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
    }
  } else {
    // fallback to contain
    if (pdfHeight > usableH) {
      pdfHeight = usableH;
      pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
    }
  }

  // compute placement (x,y in mm) — allow negative if cover produced bigger width
  const x = (pageWidth - pdfWidth) / 2;
  const y = fitMode === "top" ? marginMm : (pageHeight - pdfHeight) / 2;

  pdf.addImage(finalDataUrl, "PNG", x, y, pdfWidth, pdfHeight);

   const pdfBlob = pdf.output("blob");
   const fileURL = URL.createObjectURL(pdfBlob);
  
  // filename
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${yyyy}${mm}${dd}`;
  const fileName = `${currentKPIName || "export"}_${formattedDate}.pdf`;

  pdf.save(fileName);
}


// const { showToast } = useToast();

function formatDate() {
    const date = new Date();
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const day = daysOfWeek[date.getDay()];
    const month = months[date.getMonth()];
    const dayOfMonth = date.getDate();
    const year = date.getFullYear();

    return `${day}, ${month} ${dayOfMonth}, ${year}`;
}

// const splitValueWithUnit = (input) => {
//     if (input?.startsWith("$")) {
//         const numericPart = parseFloat(input.slice(1)); // Extract numeric part after '$'
//         const unit = input.slice(input.indexOf(numericPart.toString()) + numericPart.toString().length); // Extract the unit part
//         return {
//             numericValue: `$${numericPart}`,
//             unit: unit
//         };
//     } else {
//         return { numericValue: input, unit: '' };
//     }
// }

/* Older Function */
// const splitValueWithUnit = (input) => {
//     const regex = /^([A-Za-z\s]+)\s*([-+]?[0-9,]+\.\d{2})([A-Za-z]+)?$/; // Adjusted to include the scale unit (e.g., K, MN)
//     const match = input?.match(regex);

//     if (match) {
//         const mainUnit = match[1].trim(); // Main unit like USD or Tons
//         const numericValue = `${mainUnit} ${match[2].trim()}`; // Numeric value with main unit
//         const scaleUnit = match[3]?.trim() || ""; // Scale unit like K, MN, BN, or empty if absent
//         return { unit: scaleUnit, numericValue };
//     }

//     return "";
// };
const splitValueWithUnit = (input) => {
    // Adjusted regex to allow optional currency symbol, number with commas, and scale unit (e.g., K, MN, BN)
    // const regex = /^([^\d]+)\s*([-+]?[0-9,]+\.\d{2})([A-Za-z]+)?$/; //Earlier Regex
    if(input=='$0') {
        return { unit: "", numericValue: "0" };
    }
    const regex = /^([^\d]+)\s*([-+]?[0-9,]+\.\d+)([A-Za-z]+)?$/;
    const match = input?.match(regex);

    if (match) {
        const mainUnit = match[1].trim(); // Main unit (like '$')
        const numericValue = `${match[2].trim()}`; // Numeric value with comma and decimal
        const scaleUnit = match[3]?.trim() || ""; // Scale unit like K, MN, or empty if absent
        return { unit: scaleUnit, numericValue: `${mainUnit}${numericValue}` };
    }

    return ""; // Return empty if no match
};

function splitNumericValue(input) {
    // const match = input?.match(/^(\$?\d+(\.\d+)?)([A-Za-z]+)$/);
    const match = input?.match(/^(-?\$?\d+(\.\d+)?)([A-Za-z]+)$/);
    if (match) {
        const value = match[1]; // "$23.47" or "23.47"
        const suffix = match[3]; // "MN", "BN", "K", etc.
        return { value, suffix };
    }
    return { value: input, suffix: "" }; // Return null if the input format is invalid
}

function formatNumberWithCommas(number) {
    return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function getBNMNOrKValue(value) {
    if (value === null || value === undefined) return null;

    const absValue = Math.abs(value);

    if (absValue >= 1_000_000_000) {
        return `$${(value / 1_000_000_000).toFixed(1)}BN`;
    } else if (absValue >= 1_000_000) {
        return `$${(value / 1_000_000).toFixed(1)}MN`;
    } else if (absValue >= 1_000) {
        return `$${(value / 1_000).toFixed(1)}K`;
    } else {
        return `$${value.toFixed(1)}`;
    }
}
function getBNMNOrKValueFromMillions(inputInMillions) {
    if (inputInMillions === null || inputInMillions === undefined) return null;

    const value = inputInMillions * 1_000_000;
    const absValue = Math.abs(value);

    if (absValue >= 1_000_000_000) {
        return `${(value / 1_000_000_000).toFixed(1)}BN`;
    } else if (absValue >= 1_000_000) {
        return `${(value / 1_000_000).toFixed(1)}MN`;
    } else if (absValue >= 1_000) {
        return `${(value / 1_000).toFixed(1)}K`;
    } else {
        return `${value.toFixed(1)}`;
    }
}

function returnHyphenIfNull(value) {
    return value == null ? "-" : value
}

function getMonthsWithYear(selectedYear) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const formattedMonths = [];
    const currentDate = new Date();
    if (selectedYear && selectedYear.length > 0) {
        selectedYear.forEach((yearObj) => {
            const year = yearObj.displayText;
            months.forEach((month, index) => {
                const monthNumber = String(index + 1).padStart(2, '0');
                const monthDate = new Date(`${year}-${monthNumber}-01`);
                if (monthDate <= currentDate) {
                    formattedMonths.push({
                        id: `${year}-${index + 1}`,
                        displayText: `${month} ${year}`,
                        label: `${month} ${year}`,
                        value: `${year}-${monthNumber}-01`,
                    });
                }
            });
        });
        formattedMonths.sort((a, b) => new Date(a.value) - new Date(b.value));
    }
    return formattedMonths;
}

function getMonthsWithYearWithMaxDate(selectedYear, maxDateObject, minDateText=null) {
    // console.log("--")
    // console.log(selectedYear, maxDateObject)
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const formattedMonths = [];

    const maxYearMonth = maxDateObject?.maxYearMonth; // e.g., "OCT 2024"
    let maxYear, maxMonth;

    if (maxYearMonth) {
        const [maxMonthText, maxYearText] = maxYearMonth.split(" ");
        maxYear = parseInt(maxYearText, 10);
        maxMonth = months.indexOf(maxMonthText.charAt(0).toUpperCase() + maxMonthText.slice(1).toLowerCase()) + 1;
    }

    if (Array.isArray(selectedYear) && selectedYear.length > 0) {
        selectedYear && selectedYear.forEach((yearObj) => {
            const year = parseInt(yearObj.displayText, 10);
            months.forEach((month, index) => {
                const monthNumber = String(index + 1).padStart(2, '0');
                const monthDate = new Date(`${year}-${monthNumber}-01`);

                // Include months only up to and including maxYearMonth
                if (maxYear && (year < maxYear || (year === maxYear && index + 1 <= maxMonth))) {
                    formattedMonths.push({
                        id: `${year}-${index + 1}`,
                        displayText: `${months[index]} ${year}`,
                        label: `${months[index]} ${year}`,
                        value: `${year}-${monthNumber}-01`,
                    });
                }
            });
        });

        formattedMonths.sort((a, b) => new Date(a.value) - new Date(b.value));
    }
    if(minDateText) {
      const startIndex = formattedMonths.findIndex(item => item.displayText === minDateText);
      const filteredList = startIndex !== -1 ? formattedMonths.slice(startIndex) : formattedMonths;
      return filteredList
    }
    return formattedMonths;
}


function getMonthsWithYearRange(minYear, maxYear) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const formattedMonths = [];
    const currentDate = new Date();

    for (let year = minYear; year <= maxYear; year++) {
        months.forEach((month, index) => {
            const monthNumber = String(index + 1).padStart(2, '0');
            const monthDate = new Date(`${year}-${monthNumber}-01`);
            if (monthDate <= currentDate) {
                formattedMonths.push({
                    id: `${year}-${index + 1}`,
                    displayText: `${month} ${year}`,
                    value: `${year}-${monthNumber}-01`,
                });
            }
        });
    }

    formattedMonths.sort((a, b) => new Date(a.value) - new Date(b.value));
    return formattedMonths;
}

function getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capability, maxDateForApps) {
    const maxDateObject = maxDateForApps?.find(item => item?.appName === capability);
    const maxDate = maxDateObject ? new Date(maxDateObject.maxDate) : null;

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const formattedMonths = [];
    const currentDate = new Date();

    for (let year = minYear; year <= maxYear; year++) {
        for (let index = 0; index < months.length; index++) {
            const monthNumber = String(index + 1).padStart(2, '0');
            const monthDate = new Date(`${year}-${monthNumber}-01`);

            // Ensure month is not beyond the current date and maxDate
            if ((!maxDate || monthDate <= maxDate)) { // monthDate <= currentDate &&
                formattedMonths.push({
                    id: `${year}-${index + 1}`,
                    displayText: `${months[index]} ${year}`,
                    value: `${year}-${monthNumber}-01`,
                });
            }
        }
    }

    formattedMonths.sort((a, b) => new Date(a.value) - new Date(b.value));
    return formattedMonths;
}

function getMonthsAdjustedForCurrentDate(minYear, maxYear) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const formattedMonths = [];
    const currentDate = new Date();

    for (let year = minYear; year <= maxYear; year++) {
        for (let index = 0; index < months.length; index++) {
            const monthNumber = String(index + 1).padStart(2, '0');
            const monthDate = new Date(`${year}-${monthNumber}-01`);

            // Ensure month is not beyond the current date
            if (monthDate <= currentDate) {
                formattedMonths.push({
                    id: `${year}-${index + 1}`,
                    displayText: `${months[index]} ${year}`,
                    value: `${year}-${monthNumber}-01`,
                });
            }
        }
    }

    formattedMonths.sort((a, b) => new Date(a.value) - new Date(b.value));
    return formattedMonths;
}

function getCurrentMonthObject(appName) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonthIndex = currentDate.getMonth();
    const currentMonthName = months[currentMonthIndex];
    const maxDate = new Date(currentYear, currentMonthIndex + 1, 1);  // First day of the next month
    const maxYearMonth = `${currentMonthName} ${currentYear}`;

    return {
        appName: appName,
        maxDate: maxDate.toISOString().substring(0, 10), // Format as "YYYY-MM-DD"
        maxYear: currentYear,
        maxYearMonth: maxYearMonth
    };
}

const generateMonthsList = (years, maxDateObject) => {
    // console.log("maxDateObject", maxDateObject);
    const maxYearMonth = maxDateObject?.maxYearMonth; // e.g. "Feb 2025"

    if (!maxYearMonth) return []; // Handle case when maxYearMonth is missing

    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    let result = [];
    let idCounter = 1;
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth(); // 0-based index

    // Parse maxYearMonth (e.g., "Feb 2025" -> { maxMonthIndex: 1, maxYear: 2025 })
    const [maxMonthStr, maxYearStr] = maxYearMonth.split(" ");
    const maxMonthIndex = months.indexOf(maxMonthStr); // Get 0-based index
    const maxYear = parseInt(maxYearStr, 10);

    // Sort years to ensure ascending order
    let sortedYears = years?.sort((a, b) => a - b);

    sortedYears?.forEach((year) => {
        months.forEach((month, index) => {
            if (year === currentYear && index > currentMonth) {
                return; // Skip months beyond the current month
            }

            if (year > maxYear || (year === maxYear && index > maxMonthIndex)) {
                return; // Stop adding months beyond maxYearMonth
            }

            result.push({
                displayText: `${month} ${year}`,
                id: idCounter++,
            });
        });
    });

    return result;
};

// Example usage:
// const years = [2023, 2024, 2025];
// const maxDateObject = { maxYearMonth: "Feb 2025" };

// console.log(generateMonthsList(years, maxDateObject));



function sortData(data, columnKey, sortOrder = 'asc') {
    return data ? data.sort((a, b) => {
        let valueA = a[columnKey];
        let valueB = b[columnKey];

        if (columnKey === 'spend') {
            valueA = Number(splitNumericValue(a?.[columnKey])?.['value'])
            valueB = Number(splitNumericValue(b?.[columnKey])?.['value'])
        }

        if (valueA === null || valueA === undefined) return sortOrder === 'asc' ? 1 : -1;
        if (valueB === null || valueB === undefined) return sortOrder === 'asc' ? -1 : 1;

        if (typeof valueA === 'string' && typeof valueB === 'string') {
            return sortOrder === 'asc'
                ? valueA.localeCompare(valueB)
                : valueB.localeCompare(valueA);
        }

        // Compare numbers or other data types
        return sortOrder === 'asc' ? valueA - valueB : valueB - valueA;
    }) : []
}


function getToDateOptions(fromDate) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const toDateOptions = [];
    let idCounter = 1;

    const [fromMonthStr, fromYear] = fromDate?.split(' ') || [];
    const fromMonth = months.indexOf(fromMonthStr);
    const startDate = new Date(Number(fromYear), fromMonth);

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    const endDate = new Date(currentYear, currentMonth);

    let iterDate = new Date(startDate);
    while (iterDate <= endDate) {
        const year = iterDate.getFullYear();
        const monthIndex = iterDate.getMonth();
        const monthName = months[monthIndex];

        toDateOptions.push({
            id: idCounter++,
            displayText: `${monthName} ${year}`,
            value: `${year}-${String(monthIndex + 1).padStart(2, '0')}-01`
        });

        iterDate.setMonth(iterDate.getMonth() + 1);
    }

    return toDateOptions;
}
function getToDateOptionsWithMaxDate(fromDate, maxDateObject) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const toDateOptions = [];
    let idCounter = 1;

    const [fromMonthStr, fromYear] = fromDate?.split(' ') || [];
    const fromMonth = months.indexOf(fromMonthStr);
    const startDate = new Date(Number(fromYear), fromMonth);

    const [maxYear, maxMonth] = maxDateObject?.maxDate?.split('-') || [];
    const endDate = new Date(Number(maxYear), Number(maxMonth) - 1);

    let iterDate = new Date(startDate);
    while (iterDate <= endDate) {
        const year = iterDate.getFullYear();
        const monthIndex = iterDate.getMonth();
        const monthName = months[monthIndex];

        toDateOptions.push({
            id: idCounter++,
            displayText: `${monthName} ${year}`,
            value: `${year}-${String(monthIndex + 1).padStart(2, '0')}-01`
        });

        iterDate.setMonth(iterDate.getMonth() + 1);
    }

    return toDateOptions;
}



function getToDateOptionsForFilter(fromDate) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const toDateOptions = [];
    let idCounter = 1;

    const [fromMonthStr, fromYear] = fromDate.split(' ');
    const fromMonth = months.indexOf(fromMonthStr);
    const startDate = new Date(Number(fromYear), fromMonth);

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    const endDate = new Date(currentYear, currentMonth);

    let iterDate = new Date(startDate);
    while (iterDate <= endDate) {
        const year = iterDate.getFullYear();
        const monthIndex = iterDate.getMonth();
        const monthName = months[monthIndex];

        toDateOptions.push({
            id: idCounter++,
            displayText: `${monthName} ${year}`,
            value: `${year}-${String(monthIndex + 1).padStart(2, '0')}-01`
        });

        iterDate.setMonth(iterDate.getMonth() + 1);
    }

    return toDateOptions;
}

function calculateMonthDifference(startDate, endDate) {
    // Convert the string dates into Date objects
    const start = new Date(startDate + " 1"); // Adding day (1) to avoid invalid date
    const end = new Date(endDate + " 1");

    // Calculate the difference in months
    const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
    return months;
}

const formatIntoDropdownData = (data, originalData) => {
    // console.log(data, originalData)
    const finalData = originalData?.filter(item => data?.includes(item.displayText));
    const uniqueData = finalData?.filter((item, index, self) =>
        index === self.findIndex((t) => t.displayText === item.displayText)
    );
    // return uniqueArray.map((s, i) => ({ displayText: s, id: i + 1 }))
    // console.log(uniqueData)
    return uniqueData
}

function getOverlappingOptions(allOptions, landingPageOptions, capability="", key="", additionalOptions=[]) {
    // This function returns values to be selected for a particular dropdown based on landing page Selection
    const displayTextSet = new Set(landingPageOptions.map(item => item.displayText.toLowerCase()));
    if(capability===appNames.archlet && key==="bu") {
        additionalOptions.forEach(option => {
            displayTextSet.add(option.toLowerCase());
        });          
        // displayTextSet.add("europe");
        // displayTextSet.add("latam");
        // displayTextSet.add("pbna");
        // displayTextSet.add("pfna");
    }
    const matchingObjects = allOptions.filter(item => displayTextSet.has(item?.displayText?.toLowerCase()));
    return matchingObjects;
}

function getOverlappingOptionsV2(allOptions, landingPageOptions) {
    // This function returns values to be selected for a particular dropdown based on landing page Selection
    const displayTextSet = new Set(landingPageOptions?.map(option=>option.toLowerCase()));
    const matchingObjects = allOptions.filter(item => displayTextSet.has(item?.displayText?.toLowerCase()));
    return matchingObjects;
}

const handleDomToImgDownloadPdf = async (ref, kpiName) => {
       const node = ref.current
        try {
        const dataUrl = await domtoimage.toPng(node, {
            quality: 1,
            cacheBust: true,
        });

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4", // A2 paper size
        });

        const img = new Image();
        img.src = dataUrl;

        img.onload = () => {
                    const imgProps = pdf.getImageProperties(dataUrl);
                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();

                    let pdfWidth = pageWidth;
                    let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

                    // Resize if image is too tall
                    if (pdfHeight > pageHeight) {
                    pdfHeight = pageHeight;
                    pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
                    }

                    const x = (pageWidth - pdfWidth) / 2;
                    const y = (pageHeight - pdfHeight) / 2;

                    pdf.addImage(dataUrl, 'PNG', x, y, pdfWidth, pdfHeight);
                    

                    // Build dynamic filename in "refVal_YYYYMMDD" format
                   const today = new Date();
                   const yyyy = today.getFullYear();
                   const mm = String(today.getMonth() + 1).padStart(2, "0");
                   const dd = String(today.getDate()).padStart(2, "0");
                   const formattedDate = `${yyyy}${mm}${dd}`;

                   const fileName = `${kpiName}_${formattedDate}.pdf`;

                   pdf.save(fileName);

                //    showToast('success', "Pdf downloaded", {
                //     icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                // });

                };
                } catch (error) {
                console.error("Failed to generate PDF:", error);
        }
 };

 /* istanbul ignore next */
 function transformIndexData(data) {
    const result = {};
  
    data?.forEach(category => {
      const categoryName = category?.name;
      const names = category?.index.map(item => item?.name);
      result[categoryName] = names;
    });
  
    return result;
}

/* istanbul ignore next */
function getAdditionalDisplayTexts(A, B) {
    const bIds = new Set(B.map(item => item?.id));
    
    // Filter A to keep only items whose id is NOT in B
    const additional = A.filter(itemA => !bIds.has(itemA?.id));
    
    return additional.map(item => item?.displayText);
}

function getFirstUniqueItems(entireList, selectedList, count) {
    const selectedSet = new Set(selectedList);
    
    return entireList.filter(item => !selectedSet.has(item)).slice(0, count);
}


export const spendResilincDropdownoptions = [
    {
      label: "Download as PDF",
      icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_400_531382)">
            <path d="M3.225 0C2.345 0 1.633 0.72 1.633 1.6L1.625 14.4C1.625 15.28 2.337 16 3.217 16H12.825C13.705 16 14.425 15.28 14.425 14.4V4.8L9.625 0H3.225ZM8.825 5.6V1.2L13.225 5.6H8.825Z" fill="#8D466D"/>
          </g>
          <defs>
            <clipPath id="clip0_400_531382">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
        label: "Download as JPEG",
        icon: (
          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.225 0C1.345 0 0.633 0.72 0.633 1.6L0.625 14.4C0.625 15.28 1.337 16 2.217 16H11.825C12.705 16 13.425 15.28 13.425 14.4V4.8L8.625 0H2.225ZM7.825 5.6V1.2L12.225 5.6H7.825Z" fill="#8458CC"/>
          </svg>

        ),
      },
  ];

export {
    handleDomToImgDownloadPdf, formatDate, splitNumericValue, splitValueWithUnit, formatNumberWithCommas,
    returnHyphenIfNull, getMonthsWithYear, getToDateOptions, sortData, getMonthsWithYearRange,
    calculateMonthDifference, formatIntoDropdownData, getMonthsWithYearRangeAdjustedForMaxDate, getMonthsWithYearWithMaxDate, getToDateOptionsWithMaxDate,
    generateMonthsList, getBNMNOrKValueFromMillions, getMonthsAdjustedForCurrentDate, getCurrentMonthObject, getBNMNOrKValue, getOverlappingOptions, getOverlappingOptionsV2,
  transformIndexData, getAdditionalDisplayTexts, getFirstUniqueItems, addCoManCardIfMissing, addCategoryManagementCardIfMissing, addProcurementPerformanceCardIfMissing, addCompassCardIfMissingPGCSUser, addPGCSCardIfMissingPGCSUser
    // checkPDFDownloaded
}
